import { Component, OnInit, Input } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DialogService, TreeNode, MenuItem } from 'primeng/api';
import { Subject } from 'rxjs/Subject';
import { IPaginatedTable } from 'src/app/Interfaces/IPaginatedTable'
import { PaginatedTable } from 'src/app/Components/PaginatedTable/PaginatedTable'
import 'rxjs/add/operator/debounceTime';
import { environment } from 'src/environments/environment';
import { state, trigger, style, transition, animate } from '@angular/animations';
import { Indicator } from 'src/app/Models/Indicator'
import { Periodicity } from 'src/app/Models/Handbooks/Periodicity';
import { Activity } from 'src/app/Models/Handbooks/Activity';
import { Industry } from 'src/app/Models/Industry';
import { ReformatIndustry } from '../List/Helpers';
import { FactorsListComponent } from '../List/FactorsList';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';

@Component({
    selector: 'app-indicators-public-list',
    templateUrl: './IndicatorsPublicList.html',
    styleUrls: [],
    providers: [DialogService, CurrentLangPipe, TranslatePipe],
    animations: [
        trigger('rowExpansionTrigger', [
            state('void', style({
                transform: 'translateX(-10%)',
                opacity: 0
            })),
            state('active', style({
                transform: 'translateX(0)',
                opacity: 1
            })),
            transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class IndicatorsPublicListComponent extends PaginatedTable<Indicator> implements OnInit, IPaginatedTable<Indicator> {

    Periodicity: Periodicity = new Periodicity();
    
    getData() {
        this.isLoading = true;
        return this.http.get(`${environment.apiUrl}/api/Indicators/PagedPublic?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&filter=${this.filters}&sort=${this.sorts}`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    CurrentLang: string = 'ru';

    getActivities() {
        return this.http.get(`${environment.apiUrl}/api/Activities/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    getPeriodicities() {
        return this.http.get(`${environment.apiUrl}/api/Periodicities/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    getIndustries() {
        return this.http.get(`${environment.apiUrl}/api/Industries/Tree`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    afterPaginate() {
        this.setData(() => {
            this.isLoading = false;
        });
    }

    Name: string = '';
    NameChanged: Subject<string> = new Subject<string>();
    NameChangedCall(text: string) { this.NameChanged.next(text); }

    TaldauIdentifier: string = '';
    TaldauIdentifierChanged: Subject<string> = new Subject<string>();
    TaldauIdentifierChangedCall(text: string) { this.TaldauIdentifierChanged.next(text); }

    ActivityId: string = '';
    ActivityIdChanged: Subject<string> = new Subject<string>();
    ActivityIdChangedCall(text: string) {
        this.IndustriesSelectedNodes = [];
        this.ActivityIdChanged.next(text);
    }
    Activities: Activity[] = [];
    get ActivitiesOptions(): Array<any> {
        return this.Activities.map((x: Activity) => ({
            label: (this.CurrentLang == 'ru')
                ? x.NameRu
                : (this.CurrentLang == 'kk')
                    ? x.NameKz
                    : x.NameEn,
            value: x.Id
        }))
    }

    PeriodicityId: string = '';
    PeriodicityIdChanged: Subject<string> = new Subject<string>();
    PeriodicityIdChangedCall(text: string) { this.PeriodicityIdChanged.next(text); }
    Periodicities: Periodicity[] = [];
    get PeriodicitiesOptions(): Array<any> {
        return this.Periodicities.map((x) => ({
            label: (this.CurrentLang == 'ru')
                ? x.NameRu
                : (this.CurrentLang == 'kk')
                    ? x.NameKz
                    : x.NameEn,
            value: x.Id
        }))
    }

    get IndustryId(): string {
        return this.IndustriesSelectedNodes.map(x => x.data).join(',');
    };
    Industries: Array<Industry> = [];
    IndustriesSelectedNodes: TreeNode[] = [];
    IndustriesTree: TreeNode[] = [];
    IndustriesTreeForSphere: TreeNode[] = [];
    DeselectIndustries() {
        this.IndustriesSelectedNodes = [];
        this.filtersChanged();
    }
    IndustriesChanged() {
        this.ActivityId = '';
        this.filtersChanged();
    }
    
    public MakeUlIndustry(industry: Industry): string[] {
        return [
            industry.Name,
            ...(industry.Parent != null ? this.MakeUlIndustry(industry.Parent) : [])
        ]
    }

    //#region advanced search options, object and callbacks
    SearchPlannedAvailable = [
        { label: this.translatePipe.transform('common.available'), value: 1},
        { label: this.translatePipe.transform('common.notAvailable'), value: 2},
        { label: this.translatePipe.transform('common.anyValue'), value: 0}
    ];
    SearchVerifiedStatus = [
        { label: this.translatePipe.transform('indicators.verified'), value: 1},
        { label: this.translatePipe.transform('indicators.notVerified'), value: 2},
        { label: this.translatePipe.transform('common.anyValue'), value: 0}
    ];
    SearchPositivityStatus = [
        { label: this.translatePipe.transform('indicators.positive'), value: 1},
        { label: this.translatePipe.transform('indicators.negative'), value: 2},
        { label: this.translatePipe.transform('common.anyValue'), value: 0}
    ];
    SearchRegionDivinity = [
        { label: this.translatePipe.transform('common.yes'), value: 1},
        { label: this.translatePipe.transform('common.no'), value: 2},
        { label: this.translatePipe.transform('common.anyValue'), value: 0}
    ];
    AdvancedSearchParameters = {
        PlannedAvailable: 0,
        VerifiedStatus: 0,
        PositivityStatus: 0,
        RegionDivinity: 0,
        IdentifierContains: ''
    };
    AdvancedSearchParametersChanged: Subject<string> = new Subject<string>();
    AdvancedSearchParametersChangedOnIdentifierContains: Subject<string> = new Subject<string>();
    AdvancedSearchParametersChangedCall(text: string) {
        this.AdvancedSearchParametersChanged.next(text);
    }
    AdvancedSearchParametersChangedCallOnIdentifierContains(text: string) {
        this.AdvancedSearchParametersChanged.next(text);
    }
    AdvancedSearchConditionPassed(): number {
        let _result: number = 0;
        _result += (this.AdvancedSearchParameters.PlannedAvailable > 0 ? 1 : 0);
        _result += (this.AdvancedSearchParameters.VerifiedStatus > 0 ? 1 : 0);
        _result += (this.AdvancedSearchParameters.PositivityStatus > 0 ? 1 : 0);
        _result += (this.AdvancedSearchParameters.RegionDivinity > 0 ? 1 : 0);
        _result += (this.AdvancedSearchParameters.IdentifierContains.trim() != '' ? 1 : 0);
        return _result;
    }
    //#endregion

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public dialogService: DialogService,
        private currentLangPipe: CurrentLangPipe,
        private translatePipe: TranslatePipe,
        // private cookieService: CookieService
    ) {
        super();
        
        this.filters = this.nameSelectionOnLang()
            + `|TaldauIdentifier:${this.TaldauIdentifier}`
            + `|PeriodicityId:${this.PeriodicityId}`
            + `|ActivityId:${this.ActivityId}`
            + `|IndustryId:${this.IndustryId}`

        this.getActivities().subscribe((data: Array<Activity>) => {
            this.Activities = data
        })
        this.getPeriodicities().subscribe((data: Array<Periodicity>) => {
            this.Periodicities = data
        })
        this.getIndustries().subscribe((data: Array<Industry>) => {
            var lang = this.currentLangPipe.get()
            this.Industries = data;
            this.IndustriesTree = this.Industries.map(x => ReformatIndustry(x, lang))
            this.IndustriesTreeForSphere = this.Industries.map(x => ReformatIndustry(x, lang, true));
            this.IndustriesTreeForSphere = this.IndustriesTreeForSphere.map(x => {var _s = x; _s.selectable = false; return _s;});
        })
        
        this.NameChanged.debounceTime(700).subscribe(model => { this.Name = model; this.filtersChanged() });
        this.PeriodicityIdChanged.debounceTime(700).subscribe(model => { this.PeriodicityId = model; this.filtersChanged() });
        this.TaldauIdentifierChanged.debounceTime(700).subscribe(model => { this.TaldauIdentifier = model; this.filtersChanged() });
        this.ActivityIdChanged.debounceTime(700).subscribe(model => { this.ActivityId = model; this.filtersChanged() });

        this.AdvancedSearchParametersChanged.debounceTime(700).subscribe(model => { this.filtersChanged(); });
        this.AdvancedSearchParametersChangedOnIdentifierContains.debounceTime(700).subscribe(model => {
            this.AdvancedSearchParameters.IdentifierContains = model;
            this.filtersChanged();
        });

        this.setData();

    }

    ngOnInit() {
        this.CurrentLang = this.currentLangPipe.get();
        this.filters = this.nameSelectionOnLang()
            + `|TaldauIdentifier:${this.TaldauIdentifier}`
            + `|PeriodicityId:${this.PeriodicityId}`
            + `|ActivityId:${this.ActivityId}`
            + `|IndustryId:${this.IndustryId}`
        this.setData();
    }

    nameSelectionOnLang() {
        switch (this.CurrentLang) {
            case 'kk': { return 'NameKz:' + this.Name; }
            case 'en': { return 'NameEn:' + this.Name; }
            case 'ru':
            default: { return 'NameRu:' + this.Name; }
        }
    }

    filtersChanged() {
        let _advancedSearch = `IsPlannedAvailable:${this.AdvancedSearchParameters.PlannedAvailable == 1 ? 'true' : (this.AdvancedSearchParameters.PlannedAvailable == 2 ? 'false' : '')}`
            + `|IsPositive:${this.AdvancedSearchParameters.PositivityStatus == 1 ? 'true' : (this.AdvancedSearchParameters.PositivityStatus == 2 ? 'false' : '')}`
            + `|IsVerified:${this.AdvancedSearchParameters.VerifiedStatus == 1 ? 'true' : (this.AdvancedSearchParameters.VerifiedStatus == 2 ? 'false' : '')}`
            + `|IsDeviedByRegions:${this.AdvancedSearchParameters.RegionDivinity == 1 ? 'true' : (this.AdvancedSearchParameters.RegionDivinity == 2 ? 'false' : '')}`
            + `|IdentifierContains:${this.AdvancedSearchParameters.IdentifierContains}`

        this.filters = `${this.nameSelectionOnLang()}|TaldauIdentifier:${this.TaldauIdentifier}`
            + `|PeriodicityId:${this.PeriodicityId}|ActivityId:${this.ActivityId}|IndustryId:${this.IndustryId}|${_advancedSearch}`
        
        //this.sorts = `NameRu:true`
        this.setData(() => {
            this.isLoading = false;
        })
    }

    linkReformat(): string {
        let _advancedSearch = `IsPlannedAvailable:${this.AdvancedSearchParameters.PlannedAvailable == 1 ? 'true' : (this.AdvancedSearchParameters.PlannedAvailable == 2 ? 'false' : '')}`
            + `|IsPositive:${this.AdvancedSearchParameters.PositivityStatus == 1 ? 'true' : (this.AdvancedSearchParameters.PositivityStatus == 2 ? 'false' : '')}`
            + `|IsVerified:${this.AdvancedSearchParameters.VerifiedStatus == 1 ? 'true' : (this.AdvancedSearchParameters.VerifiedStatus == 2 ? 'false' : '')}`
            + `|IsDeviedByRegions:${this.AdvancedSearchParameters.RegionDivinity == 1 ? 'true' : (this.AdvancedSearchParameters.RegionDivinity == 2 ? 'false' : '')}`
            + `|IdentifierContains:${this.AdvancedSearchParameters.IdentifierContains}`

        this.filters = this.nameSelectionOnLang()
            + `|TaldauIdentifier:${this.TaldauIdentifier}`
            + `|PeriodicityId:${this.PeriodicityId}`
            + `|ActivityId:${this.ActivityId}`
            + `|IndustryId:${this.IndustryId}`
            + `|${_advancedSearch}`

        return `${environment.apiUrl}/api/Indicators/PagedPublicWithFactors?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&filter=${this.filters}&sort=${this.sorts}`;
    }
    getLink(): void { window.prompt(this.translatePipe.transform('actions.copyThisIntoClipboard'), this.linkReformat()) }
    rawNewTab(): void { window.open(this.linkReformat()); }

    showFactorsDialogue(row: Indicator) {
        const ref = this.dialogService.open(FactorsListComponent, {
            data: { Indicator: row },
            header: this.translatePipe.transform('indicators.listOfFactorsForSelectedIndicator'),
            width: '70%',
            contentStyle: {
                'padding-bottom': '14px',
                'padding-top': '14px'
            }
        });
    }

}